// extracted by mini-css-extract-plugin
export default {"module":"quizThree_module__eocsS","name":"quizThree_name__-MrRQ","phone":"quizThree_phone__fY0yb"};